<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h5 style="margin-bottom: 0px;">SOLICITUDES</h5>
            <h6 style="margin-top: 0px;">Gestión de Solicitudes de las áreas del Poder Judicial</h6>            
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
                <div class="area" v-if="this.Limite==false">
                    <Busqueda v-on:ValorDeConsulta ="ObtenDatos($event)" :barCode=this.Documento.CodigoBarras :actualiza=this.ActualizaConsulta />
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
                <div class="area" v-if="this.Limite==false">
                    <div class="row">
                        <div class="form-group col-6 text-left">
                            <h6 class="text-primary">{{this.Etiqueta}}</h6>
                        </div>
                        <div class="form-group col-6 text-right">
                            <h6 v-if="ConteoSolicitados1>=0">
                                <p class="text-success" v-if="ConteoSolicitados1>=0 && ConteoSolicitados1<=20">Solicitados en Guadalupe : {{this.ConteoSolicitados1}}</p>
                                <p class="text-warning" v-if="ConteoSolicitados1>20 && ConteoSolicitados1<=29">Solicitados en Guadalupe : {{this.ConteoSolicitados1}}</p>
                                <p class="text-danger" v-if="ConteoSolicitados1>=30">Solicitados en Guadalupe : {{this.ConteoSolicitados1}}</p>
                            </h6>
                            <h6 v-if="ConteoSolicitados2>=0">
                                <p class="text-success" v-if="ConteoSolicitados2>=0 && ConteoSolicitados2<=20">Solicitados en Palacio Civil : {{this.ConteoSolicitados2}}</p>
                                <p class="text-warning" v-if="ConteoSolicitados2>20 && ConteoSolicitados2<=29">Solicitados en Palacio Civil : {{this.ConteoSolicitados2}}</p>
                                <p class="text-danger" v-if="ConteoSolicitados2>=30">Solicitados en Palacio Civil : {{this.ConteoSolicitados2}}</p>
                            </h6>
                            <h6 v-if="ConteoSolicitados3>=0">
                                <p class="text-success" v-if="ConteoSolicitados3>=0 && ConteoSolicitados3<=20">Solicitados en Palacio Poniente : {{this.ConteoSolicitados3}}</p>
                                <p class="text-warning" v-if="ConteoSolicitados3>20 && ConteoSolicitados3<=29">Solicitados en Palacio Poniente : {{this.ConteoSolicitados3}}</p>
                                <p class="text-danger" v-if="ConteoSolicitados3>=30">Solicitados en Palacio Poniente : {{this.ConteoSolicitados3}}</p>
                            </h6>
                        </div>
                        
                    </div>
                    <hr>
                    <div class="row align-items-center">
                        <div class="form-group col-8" id="Area_div"> 
                            <label>Área</label>                                  
                            <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
                        </div>
                        <div class="form-group col-4" id="Materia_div" v-if="Documento.Materia!=null"> 
                                <label>Materia</label>
                                <div v-if="Documento.Materia != null">                                 
                                    <input type="text" class="form-control" v-model="Documento.Materia.Nombre" readonly />
                                </div>
                                <div v-else>
                                    <input type="text" class="form-control" readonly />
                                </div>
                        </div>
                    </div>
                    <div class="row align-items-center">
                            <div class="form-group col-4" id="TipoDocumento_div"> 
                                <label>Tipo de Documento</label>                                  
                                <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
                            </div>
                            <div class="form-group col-4" id="Anio_div"> 
                                <label>Año</label>
                                <input type="text" class="form-control" v-model="Documento.Anio" readonly/>
                            </div>
                            <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null"> 
                                <label>Consecutivo</label>                                  
                                <input type="text"  class="form-control" v-model="Documento.Consecutivo" readonly/>
                            </div>
                            <div class="form-group col-2" id="Consecutivo_div" v-else> 
                                <label>Consecutivo</label>                                  
                                <input type="text"  class="form-control" v-model="Documento.Consecutivo" readonly/>
                            </div>
                            <div class="form-group col-2" id="Consecutivo_div" v-if="Documento.Sufijo!=null"> 
                                <label>Sufijo</label>                                  
                                <input type="text"  class="form-control" v-model="Documento.Sufijo" readonly/>
                            </div>

                            
                    </div>
                    <div class="row align-items-center ">
                            <div class="form-group col-4" id="Estatus_div"> 
                                <label>Codigo</label>                                  
                                <input type="text" class="form-control" v-model="Documento.CodigoBarras" readonly/>
                            </div>
                            <div class="form-group col-4" id="Estatus_div"> 
                                <label>Estatus del Documento</label>                                  
                                <input type="text" class="form-control" v-model="Documento.TipoEstatusInventario.Nombre" readonly/>
                            </div>
                    </div>
                    <div class="row align-items-center" v-if="Documento.Anexos!=null">
                        <div class="form-group col-12" id="TipoDocumento_div">
                            <label>Observaciones y/o Anexos</label>
                            <input type="text" class="form-control" v-model="Documento.Anexos" readonly />
                        </div>
                    </div>
                    <div class="row align-items-center" v-if="Documento.AmparoDocumentoPrincipal!=null">
                        <div class="form-group col-12" id="Estatus_div">
                            <label class="text-success"><b>Amparo del Documento {{Documento.AmparoDocumentoPrincipal.TipoDocumento.Nombre}} {{Documento.AmparoDocumentoPrincipal.Consecutivo}}/{{Documento.AmparoDocumentoPrincipal.Anio}} del {{Documento.AmparoDocumentoPrincipal.Area.Nombre}}</b></label>
                        </div>
                    </div>
                    <div v-if="Documento.Referencias.length>0">
                        <h6 class="text-success">Documentos Relacionados</h6>
                        <hr>
                        <ul >
                        <li v-for="elemento in Documento.Referencias">
                            <span>{{elemento.Referencia.Area.Nombre}},&nbsp;&nbsp;&nbsp;documento: {{elemento.Referencia.Consecutivo}}/{{elemento.Referencia.Anio}},&nbsp;&nbsp;&nbsp; relación por: {{elemento.TipoReferencia.Nombre}}</span>
                        </li>
                        </ul>
                    </div>
                    <div v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId == 1">
                        <div v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId!=11 && Documento.Area.AreaId!=12 && Documento.Area.AreaId!=13 && Documento.Area.AreaId!=14 && Documento.Area.AreaId!=15 && Documento.Area.AreaId!=16)">
                                    <h6 class="text-primary">Datos del Juicio</h6>
                                    <hr>
                        </div>
                        <div class="row" v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId!=11 && Documento.Area.AreaId!=12 && Documento.Area.AreaId!=13 && Documento.Area.AreaId!=14 && Documento.Area.AreaId!=15 && Documento.Area.AreaId!=16)">
                                <div class="form-group col-1" id="Estatus_div">
                                <label>Tipo:</label>
                                </div>
                                <div class="form-group col-5" id="Estatus_div">
                                <label>{{Documento.Juicio.Juicio}}</label>
                                </div>
                            <div class="form-group col-1" id="Estatus_div">
                            <label>Tramite:</label>
                            </div>
                            <div class="form-group col-5" id="Estatus_div">
                            <label>{{Documento.Juicio.Tramite}}</label>
                            </div>
                        </div>

                        <div>
                            <h6 class="text-primary">Partes</h6>
                            <hr>
                        </div>
                        
                        <div id="Partes_table" class="table-responsive">
                                <table class="table table-striped table-light table-hover table-sm">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th >Parte</th>
                                            <th >Nombre</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-dark">
                                        <tr v-if="Documento.Partes.length <= 0">
                                            <td colspan="12" class="text-center">No hay registro Partes</td>
                                        </tr>
                                        <tr v-else v-for="parte in Documento.Partes" :key="parte.Documento_Referencia">
                                            <td>{{parte.Tipo_Parte}}</td>
                                            <td>{{parte.Nombre}} {{parte.ApellidoPaterno}} {{parte.ApellidoMaterno}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                        
                        <div >
                            <h6 class="text-primary">Datos de Inventario</h6>
                            <hr>
                        </div>
                        <div >
                            <h6 class="text-primary">Tomos</h6>
                        </div>
                        <div id="Volumen_table" class="table-responsive" >
                            <table class="table table-striped table-light table-hover table-sm">
                                <thead class="thead-dark">
                                  <tr>
                                    <th>No.</th>
                                    <th>Fojas</th>
                                    <th>Ubicación</th>
                                    <th>Contenido</th>
                                    <th>Estatus</th>
                                  </tr>
                                </thead>
                                <tbody class="text-dark">
                                        <tr v-if="Documento.Volumenes.length <= 0">
                                            <td colspan="12" class="text-center">No hay registro del Volumen</td>
                                        </tr>
                                        <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                                            <td width="50">{{detalle.NumVolumen}}</td>
                                            <td width="60">{{detalle.Fojas}}</td>
                                            <td width="300" v-html="DetallesUbicacionVolumen(detalle, Documento.SedeArchivo)"></td>
                                            <td width="400" v-html="DesglosaContenido(detalle)"></td>
                                            <td width="200" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                                                <h6><span class="badge badge-pill badge-success text-center">Disponible en Archivo</span></h6>
                                            </td>
                                            <td width="200" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                                                <h6><span class="badge badge-pill badge-warning text-center">En tramite por solicitud de prestamo</span></h6>
                                                <label class="text-danger" v-if="EstadoSolicitud.SolicitudDocumentoId!=0">Solicitado en : {{EstadoSolicitud.FechaRegistro }}</label>
                                            </td>
                                            <td width="200" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                                                <h6><span class="badge badge-pill badge-danger text-center">No Disponible para Solicitud</span></h6>
                                                <label class="text-danger" v-if="detalle.MovimientoVolumen!=null && detalle.MovimientoVolumen.SolicitudDocumentoId!=null">En juzgado por prestamo vigente con el Archivo Judicial</label>
                                            </td>
                                        </tr>
                                </tbody>
                                
                            </table>
                            
                        </div>
                        <div v-if="Documento.Incidentes.length>0">
                            <h6 class="text-primary">Incidentes del documento</h6>
                        </div>
                        <div id="Incidentes_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Incidentes.length>0">
                            <table class="table table-striped table-light table-hover table-sm">
                                <thead class="thead-dark">
                                    <tr>
                                    <th>No.</th>
                                    <th>Tipo Incidente</th>
                                    <th>Ubicacion</th>
                                    <th>Estatus</th>
                                    <th></th>
                                    <!-- <th></th> -->
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="Documento.Incidentes.length <= 0">
                                    <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                                    </tr>
                                    <tr v-else v-for="detalle in Documento.Incidentes" :key="detalle.IncidenteId">
                                    <td width="50">{{detalle.NumeroIncidente}}</td>
                                    <td width="550">{{detalle.TipoIncidente}}</td>
                                    <td width="400" v-html="DetallesUbicacionIncidente(detalle, Documento.SedeArchivo)"></td>
                                    <td width="250" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                                        <h6><span class="badge badge-pill badge-success text-center">Disponible en Archivo</span></h6>
                                    </td>
                                    <td width="250" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                                        <h6><span class="badge badge-pill badge-warning text-center">En tramite por solicitud de prestamo</span></h6>
                                    </td>
                                    <td width="250" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                                        <h6><span class="badge badge-pill badge-danger text-center">No Disponible para Solicitud</span></h6>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="Documento.Tercerias.length>0">
                            <h6 class="text-primary">Tercerías del documento</h6>
                        </div>
                        <div id="Tercerias_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Tercerias.length>0">
                            <table class="table table-striped table-light table-hover table-sm">
                                <thead class="thead-dark">
                                <tr>
                                    <th>No.</th>
                                    <th>Tipo Tercería</th>
                                    <th>Ubicacion</th>
                                    <th>Estatus</th>
                                    <!-- <th></th> -->
                                </tr>
                                </thead>
                                <tbody class="text-dark">
                                <tr v-if="Documento.Tercerias.length <= 0">
                                    <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                                </tr>
                                <tr v-else v-for="detalle in Documento.Tercerias" :key="detalle.TerceriaId">
                                    <td width="50">{{detalle.NumeroTerceria}}</td>
                                    <td width="550">{{detalle.TipoTerceria}}</td>
                                    <td width="400" v-html="DetallesUbicacionTerceria(detalle, Documento.SedeArchivo)"></td>
                                    <!-- <td width="400" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                                    <td width="400" v-else>{{detalle.Area.Nombre}}, Usuario: {{detalle.MovimientoTerceria.UsuarioQuienRecibe!= null ? detalle.MovimientoTerceria.UsuarioQuienRecibe.Nombre : ""}} {{detalle.MovimientoTerceria.UsuarioQuienRecibe!=null ? detalle.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno : ""}} {{detalle.MovimientoTerceria.UsuarioQuienRecibe!=null ? detalle.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno : ""}}</td> -->
                                    <td width="250" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                                        <h6><span class="badge badge-pill badge-success text-center">Disponible en Archivo</span></h6>
                                    </td>
                                    <td width="250" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                                        <h6><span class="badge badge-pill badge-warning text-center">En tramite por solicitud de prestamo</span></h6>
                                    </td>
                                    <td width="250" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                                        <h6><span class="badge badge-pill badge-danger text-center">No Disponible para Solicitud</span></h6>
                                    </td>
                                    <!-- <td width="50" class="category_enabled" style="float: left;" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                                    <input type="checkbox" v-model="ListaTercerias" v-bind:value="detalle.TerceriaId" checked/>
                                    </td>
                                    <td v-else></td> -->
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <!-- <div class="row" v-if="(ListaVolumenes.length>0 || ListaIncidentes.length>0 || ListaTercerias.length>0) && ShowBotonSolicitar==true ">
                                <div class="form-group col-11 text-right">
                                    <label>Urgente:</label>
                                </div>
                                <div class="form-group col-1 text-left">
                                    <input type="checkbox" v-model="Urgente"/>
                                </div>
                                <div class="form-group col-12" id="Observaciones_div">
                                    <label>Observaciones:</label>
                                    <textarea type="text" class="form-control" rows="3" v-model="ObservacionesJuzgado" placeholder="Escriba una observación sobre la Solicitud si es necesario"></textarea>
                                </div>
                        </div> -->
                        
                        <div id="BotonBusqueda_div" class="text-right" v-if="ShowBotonSolicitar==true">
                            <button class="btn btn-sm btn-success"  @click='SolicitarDocumento(Documento.InventarioDocumentoId)'>Solicitar Documento</button>
                        </div>
                    </div>
                </div>
                
                <div class="area" v-if="InfoDoc!=null && InfoDoc.InventarioDocumentoId!=null">
                    <div>
                        <h6 class="text-primary">Documento Principal</h6>
                        <hr>
                    </div>
                    <div class="row align-items-center">
                        <div class="form-group col-6"> 
                            <label>Área</label>                                  
                            <input type="text" class="form-control" v-model="InfoDoc.Area.Nombre" readonly />
                        </div>
                        <div class="form-group col-6"> 
                                <label>Materia</label>
                                <div v-if="Documento.Materia != null">                                 
                                    <input type="text" class="form-control" v-model="InfoDoc.Materia.Nombre" readonly />
                                </div>
                                <div v-else>
                                    <input type="text" class="form-control" readonly/>
                                </div>
                        </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="form-group col-6"> 
                            <label>Año</label>                                  
                            <input type="text" class="form-control" v-model="InfoDoc.Anio" readonly />
                        </div>
                        <div class="form-group col-6"> 
                                <label>Consecutivo</label>
                                <div >                                 
                                    <input type="text" class="form-control" v-model="InfoDoc.Consecutivo" readonly />
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="this.VisibleModalJuzgado==true">
            <modalJuzgado :inventarioDocumentoId= this.volIdModal :volumenSolicitud= this.VolumenesModal :incidenteSolicitud= this.IncidentesModal :AreaDatos= this.areaModal @dialogo='EstatusModal($event)'></modalJuzgado>
        </div>
        
    </div>
    
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import FiltroDeBusqueda from '@/components/ArchivoJudicial/Comun/ConsultaDocumento.vue'
import ModalCapturaJuzgado from '@/components/ArchivoJudicial/Comun/DatosJuzgadoSolicitud.vue'


export default {
    
    components : {
        Busqueda: FiltroDeBusqueda,
        modalJuzgado: ModalCapturaJuzgado
    },
    data(){
        return{
            Documento: {
                InventarioDocumentoId: "",
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Año: "",
                Consecutivo: "",
                CodigoBarras: "",
                Fecha_Registro: null,
                Sufijo: null,
                TipoEstatusInventario: {},
                Volumenes :[],
                Partes: [],
                Referencias: []
            },
            InfoDoc :{
                InventarioDocumentoId: null,
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Año: "",
                Consecutivo: "",
            },
            VisibleModalJuzgado: {
             type: Boolean,
             default: false
            },
            ObservacionesJuzgado: "",
            Limite: false,
            volIdModal: 0,
            areaModal: {
                AreaId: 0,
                Nombre: ""
            },
            ActualizaConsulta:{
                type: Boolean,
                default: false,
            },
            AreaArchivo: {
                type: Boolean,
                default: false
            },
            UsuarioJuzgado: {},
            ConteoSolicitados1: 0,
            ConteoSolicitados2: 0,
            ConteoSolicitados3: 0,
            ConteoPendientes1 : 0,
            ConteoPendientes2 : 0,
            ConteoPendientes3 : 0,
            ListaVolumenes:[],
            ListaIncidentes: [],
            ListaTercerias: [],
            VolumenesModal: [],
            IncidentesModal: [],
            TerceriasModal:[],
            SeleccionarTodos:false,
            ShowBotonCheck: false,
            ShowBotonSolicitar : false,
            Etiqueta: "",
            Urgente: false,
            EstadoSolicitud : {
                SolicitudDocumentoId: 0,
                FechaRegistro:""
            },
            porRecibir :[]
        }
    },
    methods: {
        obtenFechaConFormato: function(fechaRegistro) {
            return moment(fechaRegistro).format("DD-MM-YYYY h:mm a");
        },
        ObtenDatos(datos){
            if(datos.DocumentoConsulta.SolicitudActualTramite!=null)
            {
                this.EstadoSolicitud.SolicitudDocumentoId = datos.DocumentoConsulta.SolicitudActualTramite.SolicitudDocumentoId;
                this.EstadoSolicitud.FechaRegistro = moment(datos.DocumentoConsulta.SolicitudActualTramite.FechaRegistro).format('DD/MM/YYYY');

            }else
            {
                this.EstadoSolicitud.SolicitudDocumentoId = 0;
            }
            let sedeASolicitar = datos.DocumentoConsulta.SedeArchivo.SedeArchivoId;

                if(this.areaModal.Area.AreaId== datos.DocumentoConsulta.Area.AreaId || this.areaModal.Area.AreaId==21)
                {
                    this.ListaVolumenes=[];
                        this.ListaIncidentes = [];
                        this.ListaTercerias = [];
                        this.Documento = datos.DocumentoConsulta;
                        if(this.Documento.Anexos!=null)
                        {
                            this.Documento.Volumenes[0].AnexosVolumen=this.Documento.Anexos;
                        }
                        
                        this.InfoDoc = datos.DocumentoReferenciado;
                        this.UsuarioJuzgado = datos.UserId;
                        if(this.InfoDoc!=null)
                        {
                            this.Etiqueta = "Datos del Documento Referencia"
                        }
                        else
                        {
                            this.Etiqueta = "Datos del Documento"
                        };
                        this.VerificarVolumenes(enumeraciones.areasArchivo.General);
                    if(this.VerificaConteoSede(sedeASolicitar)==true)
                    {
                        comun.mensajeDeAlerta("Ha llegado al Limite de Solicitudes por dia para sede de : " + datos.DocumentoConsulta.SedeArchivo.Nombre, null, null);
                        
                        this.ShowBotonSolicitar = false;
                    };
                    if(this.Documento.SolicitudActualTramite!=null)
                    {
                        comun.mensajeDeAlerta('<label class="text-warning">Este documento tiene una solicitud de prestamo en tramite.</label><br>Solicitado el: '  + this.obtenFechaConFormato(this.Documento.SolicitudActualTramite.FechaRegistro), null, null);
                    }
                    if(datos.Listado!=null)
                    {   
                        var nombreJuzgado = this.areaModal.Area.Nombre
                        var texto = '';
                        texto = texto + '<b class="text-warning">Este documento se encuentra en Juzgado : &nbsp' + nombreJuzgado + '&nbsp</b><br/>';
                        texto = texto + '<b class="text-warning">Esta registrado en Listado de Archivo de &nbsp' + (datos.Listado.Devolucion==false ? '1a Vez' : 'Devueltos') + '&nbsp</b><br/>';
                        texto = texto + '<b class="text-warning">Fecha para envió  : &nbsp' + moment(datos.Listado.FechaEnvio).format('DD/MM/YYYY')+ '&nbsp</b>';
                        comun.mensajeDeAlerta(texto, null, null);
                    };
                    this.PorRecibir= this.AlertaRecepcion(datos.DocumentoConsulta.Volumenes);
                    if(this.PorRecibir.length>0)
                    {
                      comun.mensajeDeAlerta('</br><label class="text-warning">Ubicación Actual : ' + this.PorRecibir[0].Ubicacion + '.</label></br><label class="text-warning">Este documento esta en proceso de Recepción por : ' + this.PorRecibir[0].Destino + '.</label></br>Enviado el: '  + this.PorRecibir[0].FechaEnvio, null, null);
                    }

                    
                }
                else
                {
                    comun.mensajeDeAlerta("No puede Consultar un Documento que no corresponde a " + this.areaModal.Area.Nombre, null, null);
                }
        },
        SolicitarDocumento (valor){
            let urgente = this.Urgente!=false ? 'Urgente' : '';
            this.VolumenesModal = this.SeleccionarVolumenes();
            this.IncidentesModal = this.SeleccionarIncidentes();
            this.TerceriasModal = this.SeleccionarTercerias();
            let AreaSolicita = this.areaModal.Area.AreaId !=21 ?  this.areaModal.Area.AreaId : this.Documento.Area.AreaId;
            

            if(this.VolumenesModal.length>0 || this.IncidentesModal.length>0 || this.TerceriasModal.length>0)
            {
                let sedeASolicitar = this.Documento.SedeArchivo.SedeArchivoId;

                var peticion= {
                    "SolicitudesJuzgados": {
                        "UsuarioIdQuienSolicita": {"IdUsuario": this.UsuarioJuzgado.IdUsuario},
                        "AreaIdQueSolicita": {"AreaId" : AreaSolicita}//this.areaModal.Area.AreaId}
                    },
                    "SolicitudesDocumentos":{
                        "InventarioDocumentoId": this.Documento.InventarioDocumentoId,
                        "FechaRegistro": null,
                        "TipoEstatusSolicitud": {"TipoEstatusSolicitudDocumentoId": 1},
                        "ObservacionesJuzgado": urgente,
                    },
                    VolumenesEnSolicitud: this.GeneramosListaVolumenes(),
                    IncidentesEnSolicitud: this.GeneramosListaIncidentes(),
                    TerceriasEnSolicitud: this.GeneramosListaTercerias()
                };
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.NuevaSolicitudInterna, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                        if(respuesta.data.SiHayError)
                        {
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        }
                        else
                        {
                            if(this.Documento.SedeArchivo.SedeArchivoId==1)
                            {
                                this.ConteoSolicitados1 = this.ConteoSolicitados1 + 1;

                            };
                            if(this.Documento.SedeArchivo.SedeArchivoId==2)
                            {
                                this.ConteoSolicitados2 = this.ConteoSolicitados2 + 1;

                            };
                            if(this.Documento.SedeArchivo.SedeArchivoId==3)
                            {
                                this.ConteoSolicitados3 = this.ConteoSolicitados3 + 1;

                            }
                            
                            this.ListaVolumenes = [];
                            this.ListaIncidentes = [];
                            this.ListaTercerias=[];
                            this.Urgente = false
                        }
                        comun.SeEstaCargandoInformacion(false);
                        this.ActualizaConsulta = true;
                    }).catch(excepcion => {
                        console.log(excepcion);
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        
                    });
            }
            else{
                comun.mensajeDeAlerta("Seleccione los Volumenes, Incidentes y/o Tercerías deseados para la Solicitud", null, null);
            }
        this.ActualizaConsulta = false; 
        },
        EstatusModal(valor){
            this.VisibleModalJuzgado = valor;
            if(this.VisibleModalJuzgado == true)
            {
                this.ActualizaConsulta = false;
            }
            else
            {
                this.ActualizaConsulta = true;
                this.ObtenConteo();
            }
        },
        ObtenConteo(){
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.Conteo, null,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {   
                    this.ConteoSolicitados1 = respuesta.data.CuentaSolicitadosSede1;
                    this.ConteoSolicitados2 = respuesta.data.CuentaSolicitadosSede2;
                    this.ConteoSolicitados3 = respuesta.data.CuentaSolicitadosSede3;
                    this.ConteoPendientes1 = respuesta.data.CuentaPendientesSede1;
                    this.ConteoPendientes2 = respuesta.data.CuentaPendientesSede2;
                    this.ConteoPendientes3 = respuesta.data.CuentaPendientesSede3;
                    comun.SeEstaCargandoInformacion(false);
                    
                    // if (this.ConteoPendientes1>0 )
                    // {
                    //     this.Limite = true;
                    //     comun.mensajeDeAlerta("Hay Solicitudes pendientes por tramitar, Verifique con la Dirección del Archivo Judicial.", null, null);
                    // }
                    // else
                    // {
                    //     // if (this.ConteoSolicitados < 30)
                    //     // {
                    //     //     this.Limite= false;
                    //     // }
                    //     // else
                    //     // {
                    //     //     this.Limite = true
                    //     //     comun.mensajeDeAlerta("Se ha alcanzado el limite de solicitudes por dia", null, null);
                    //     // };
                    // }
                    

                }
                comun.SeEstaCargandoInformacion(false);
                })
            .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                    
            })
        
        },
        SeleccionarVolumenes(){
            let VolumenesEnSolicitud = [];
            this.ListaVolumenes.forEach((element) =>{
                let AgregaVol = this.Documento.Volumenes.find(vol =>vol.VolumenId == element);
                VolumenesEnSolicitud.push(
                    AgregaVol.VolumenId)
            });
            return VolumenesEnSolicitud;
        },
        SeleccionarIncidentes(){
            let IncidentesEnSolicitud = [];
            this.ListaIncidentes.forEach((element) =>{
                let AgregaIncidente = this.Documento.Incidentes.find(incidente =>incidente.IncidenteId == element);
                IncidentesEnSolicitud.push(
                    AgregaIncidente.IncidenteId)
            });
            return IncidentesEnSolicitud;
        },
        SeleccionarTercerias(){
            let TerceriasEnSolicitud = [];
            this.ListaTercerias.forEach((element) =>{
                let AgregaTerceria = this.Documento.Tercerias.find(terceria =>terceria.TerceriaId == element);
                TerceriasEnSolicitud.push(
                    AgregaTerceria.TerceriaId)
            });
            return TerceriasEnSolicitud;
        },
        SelectAll(){
            this.ListaVolumenes = [];
            this.ListaIncidentes=[];
            this.ListaTercerias=[];
            if(this.SeleccionarTodos == false)
            {
                for (let i in this.volumenesJuzgado)
                {
                    this.ListaVolumenes.push(this.volumenesJuzgado[i].VolumenId)
                }
            };

        },
        VerificarVolumenes(areaId){
            
            let _this=this;

            $.each(this.Documento.Volumenes, function(indice, volumen)
            { 
            
                if(volumen.EstatusVolumenes.TipoEstatusVolumenId == enumeraciones.TipoEstatusVolumen.Disponible &&  volumen.Area.AreaId == areaId)
                {
                    _this.ListaVolumenes.push(volumen.VolumenId);
                };
            });
            if(this.Documento.Incidentes.length>0)
            {
                $.each(_this.Documento.Incidentes, function(indice, volumen)
                { 
                
                if(volumen.EstatusVolumenes.TipoEstatusVolumenId == enumeraciones.TipoEstatusVolumen.Disponible &&
                    volumen.Area.AreaId == areaId)
                    {
                        _this.ListaIncidentes.push(volumen.IncidenteId);
                    };
                });
            };
            if(this.Documento.Tercerias.length>0)
            {
                $.each(_this.Documento.Tercerias, function(indice, volumen)
                { 
                    if(volumen.EstatusVolumenes.TipoEstatusVolumenId == enumeraciones.TipoEstatusVolumen.Disponible &&  volumen.Area.AreaId == areaId)
                    {
                        _this.ListaTercerias.push(volumen.TerceriaId);
                    };
                });
            }
            
            if(this.Documento.Volumenes.length==this.ListaVolumenes.length && this.Documento.Incidentes.length==this.ListaIncidentes.length && this.Documento.Tercerias.length==this.ListaTercerias.length)
            {
                this.ShowBotonSolicitar=true;
            }
            else{
                this.ShowBotonSolicitar=false;
                }
            
        },
        DesglosaContenido: function (datos){
            let Contenido ="";
            if(datos.NumVolumen==1)
            {
                if(datos.Amparos!=null && datos.Amparos.length>0)
                {
                Contenido= Contenido +"<b class='text-primary'>AMPAROS</b><br/>";
                        $.each(datos.Amparos, function(index, enVolumen)
                        {
                        Contenido = Contenido + "Consecutivo: "+ enVolumen.AmparosDelDocumento.Consecutivo +"/" + enVolumen.AmparosDelDocumento.Anio + "<br/>";
                        })
                };
                if(datos.IncidenteVolumen!=null && datos.IncidenteVolumen.length>0)
                    {
                    Contenido = Contenido +"<b class='text-primary'>INCIDENTES</b><br/>";
                        $.each(datos.IncidenteVolumen, function(index, enVolumen)
                        {
                        Contenido = Contenido + "No: "+ enVolumen.NumeroIncidente + ",  Tipo: " + enVolumen.TipoIncidente + "<br/>";
                        })
                    }
                if(datos.AnexosVolumen!=null)
                {
                    Contenido= Contenido + "<b class='text-primary'>OBSERVACIONES</b><br/>" + datos.AnexosVolumen
                }
            }
            
            return Contenido;
        },
        GeneramosListaVolumenes(){
        var lista= [];
        this.VolumenesModal.forEach(function (volumenId){
          lista.push({
            SolicitudDocumentoId: 0,
            VolumenId: volumenId})
          });
        return lista;
        },
        GeneramosListaIncidentes(){
        var lista= [];
        this.IncidentesModal.forEach(function (incidenteId){
          lista.push({
            SolicitudDocumentoId: 0,
            IncidenteId: incidenteId})
          });
        return lista;
        },
        GeneramosListaTercerias(){
            var lista= [];
            this.TerceriasModal.forEach(function (terceriaId){
            lista.push({
                SolicitudDocumentoId: 0,
                TerceriaId: terceriaId})
            });
            return lista;
        },
        DetallesUbicacionVolumen(dato, sede){
            let detalles ='';
            if(dato.Area.AreaId==21)
            {
                detalles = detalles + dato.Area.Nombre + '<br>';
                detalles = detalles + "Sede : " + sede.Nombre;
            }
            else
            {
                if(dato.MovimientoVolumen!=null && dato.MovimientoVolumen.AreaExterna!=null && dato.MovimientoVolumen.AreaExterna.AreaExternaId!=null)
                {
                    detalles = detalles + 'Recibido por: '  + (dato.MovimientoVolumen.DetallesExternos.Nombre!=null ? dato.MovimientoVolumen.DetallesExternos.Nombre : '' ) + '<br>';
            
                    switch (dato.MovimientoVolumen.AreaExterna.AreaExternaId)
                    {
                        case 1: 
                        detalles = detalles + "Notaría No : " + (dato.MovimientoVolumen.DetallesExternos.Numero!=0 ? dato.MovimientoVolumen.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 2: 
                        detalles = detalles + "Juzgado de Distrito No : " + (dato.MovimientoVolumen.DetallesExternos.Numero!=0 ? dato.MovimientoVolumen.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 4: 
                        detalles = detalles + "Tribunal Colegiado no : " + (dato.MovimientoVolumen.DetallesExternos.Numero!=0 ? dato.MovimientoVolumen.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 5: 
                        detalles = detalles + "Ministerio Público No : " + (dato.MovimientoVolumen.DetallesExternos.Numero!=0 ? dato.MovimientoVolumen.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 6: 
                        detalles = detalles + "Supremo Tribunal : "  + '<br>';
                        break;
                    }
                    detalles = detalles  + 'Observaciones: ' + (dato.MovimientoVolumen.DetallesExternos.Observaciones!=null ? dato.MovimientoVolumen.DetallesExternos.Observaciones : '') + '<br>';
                    detalles = detalles  + 'Fecha de Envío: ' + this.obtenFechaConFormato(dato.MovimientoVolumen.FechaMovimiento);
                }
                else
                {
                    let nombreUsuario = '';
                    if(dato.MovimientoVolumen!=null && dato.MovimientoVolumen.FechaRecepcion==null)
                    {
                        detalles = detalles +  '<b class="text-primary">' + dato.MovimientoVolumen.AreaQuePresta.Nombre + '</b><br>';
                    }
                    else
                    {
                        detalles = detalles +  '<b class="text-primary">' + dato.Area.Nombre + '</b><br>';
                    }
                    if(dato.MovimientoVolumen!=null && dato.MovimientoVolumen.FechaRecepcion==null)
                    {
                        if(dato.MovimientoVolumen.SolicitudDocumentoId!=null && dato.MovimientoVolumen.SolicitudDocumentoId!=undefined && dato.MovimientoVolumen.SolicitudDocumentoId!=0)
                        {
                            detalles = detalles + '<b class="text-danger">En proceso de Recepción por Autorización de Prestamo para : ' + dato.MovimientoVolumen.AreaQueRecibe.Nombre + '</b><br>';
                        }
                        else
                        {
                            detalles = detalles + '<b class="text-danger">En proceso de Recepción por : ' + dato.MovimientoVolumen.AreaQueRecibe.Nombre + '</b><br>';
                        }
                        
                    };
                    
                    if(dato.MovimientoVolumen!=null && dato.MovimientoVolumen.UsuarioQuienRecibe!=null)
                    {
                        if(dato.MovimientoVolumen.UsuarioQuienRecibe.IdUsuario==6)
                        {
                            nombreUsuario = "No Asignado"
                        }
                        else
                        {
                            nombreUsuario = dato.MovimientoVolumen.UsuarioQuienRecibe.Nombre + " " + dato.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno + " " + (dato.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno!=null ? dato.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno : "")
                        }
                    }
                    else
                    {
                        nombreUsuario = "No Asignado"
                    };
                    if(dato.MovimientoVolumen!=null)
                    {
                        detalles = detalles + "Usuario : " + nombreUsuario+ '<br>';
                        detalles = detalles + 'Fecha de Envío :' + this.obtenFechaConFormato(dato.MovimientoVolumen.FechaMovimiento);
                    }
                    
                }
            }
            return detalles;
        },
        DetallesUbicacionIncidente(dato, sede){
            let detalles =''
            if(dato.Area.AreaId==21)
            {
                detalles = detalles +  dato.Area.Nombre + '<br>';
                detalles = detalles + "Sede : " + sede.Nombre;
            }
            else
            {
                if(dato.MovimientoIncidente.AreaExterna!=null && dato.MovimientoIncidente.AreaExterna.AreaExternaId!=null)
                {
                    detalles = detalles + 'Recibido por: '  + (dato.MovimientoVolumen.DetallesExternos.NombreReceptor!=null ? dato.MovimientoIncidente.DetallesExternos.NombreReceptor : '' ) + '<br>';
            
                    switch (dato.MovimientoIncidente.AreaExterna.AreaExternaId)
                    {
                        case 1: 
                        detalles = detalles + "Notaría No : " + (dato.MovimientoIncidente.DetallesExternos.Numero!=0 ? dato.MovimientoIncidente.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 2: 
                        detalles = detalles + "Juzgado de Distrito No : " + (dato.MovimientoIncidente.DetallesExternos.Numero!=0 ? dato.MovimientoIncidente.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 4: 
                        detalles = detalles + "Tribunal Colegiado no : " + (dato.MovimientoIncidente.DetallesExternos.Numero!=0 ? dato.MovimientoIncidente.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 5: 
                        detalles = detalles + "Ministerio Público No : " + (dato.MovimientoIncidente.DetallesExternos.Numero!=0 ? dato.MovimientoIncidente.DetallesExternos.Numero : '') + '<br>';
                        break;
                    }
                    detalles = detalles  + 'Observaciones: ' + (dato.MovimientoIncidente.DetallesExternos.Observaciones!=null ? dato.MovimientoIncidente.DetallesExternos.Observaciones : '') + '<br>';
                    detalles = detalles  + 'Fecha de Envío: ' + this.obtenFechaConFormato(dato.MovimientoIncidente.FechaMovimiento);
                }
                else
                {
                    let nombreUsuario = '';
                    if(dato.MovimientoIncidente.FechaRecepcion==null)
                    {
                    detalles = detalles +  '<b class="text-primary">' + dato.MovimientoIncidente.AreaQuePresta.Nombre + '</b><br>';
                    }
                    else
                    {
                    detalles = detalles +  '<b class="text-primary">' + dato.Area.Nombre + '</b><br>';
                    }
                    if(dato.MovimientoIncidente.FechaRecepcion==null)
                    {
                        detalles = detalles + '<b class="text-danger">En proceso de Recepción por: ' + dato.MovimientoIncidente.AreaQueRecibe.Nombre + '</b><br>';
                    };
                    if(dato.MovimientoIncidente.UsuarioQuienRecibe!=null)
                    {
                        if(dato.MovimientoIncidente.UsuarioQuienRecibe.IdUsuario==6)
                        {
                            nombreUsuario = "No Asignado"
                        }
                        else
                        {
                            nombreUsuario = dato.MovimientoIncidente.UsuarioQuienRecibe.Nombre + " " + dato.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno + " " + (dato.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno!=null ? dato.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno : "")
                        }
                    }
                    else
                    {
                        nombreUsuario = "No Asignado"
                    }
                    detalles = detalles + "Usuario : " + nombreUsuario + '<br>';
                    detalles = detalles + 'Fecha de Envío :' + this.obtenFechaConFormato(dato.MovimientoIncidente.FechaMovimiento)
                }
            }
            return detalles;
        },
        DetallesUbicacionTerceria(dato, sede){
            let detalles =''
            if(dato.Area.AreaId==21)
            {
                detalles = detalles + dato.Area.Nombre + '<br>';
                detalles = detalles + "Sede : &nbsp" + sede.Nombre;
            }
            else
            {
                if(dato.MovimientoTerceria.AreaExterna!=null && dato.MovimientoTerceria.AreaExterna.AreaExternaId!=null)
                {
                    detalles = detalles + 'Recibido por: &nbsp'  + (dato.MovimientoTerceria.DetallesExternos.NombreReceptor!=null ? dato.MovimientoTerceria.DetallesExternos.NombreReceptor : '' ) + '<br>';
            
                    switch (dato.MovimientoTerceria.AreaExterna.AreaExternaId)
                    {
                        case 1: 
                        detalles = detalles + "Notaría No : &nbsp" + (dato.MovimientoTerceria.DetallesExternos.Numero!=0 ? dato.MovimientoTerceria.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 2: 
                        detalles = detalles + "Juzgado de Distrito No : &nbsp" + (dato.MovimientoTerceria.DetallesExternos.Numero!=0 ? dato.MovimientoTerceria.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 4: 
                        detalles = detalles + "Tribunal Colegiado no : &nbsp" + (dato.MovimientoTerceria.DetallesExternos.Numero!=0 ? dato.MovimientoTerceria.DetallesExternos.Numero : '') + '<br>';
                        break;
                        case 5: 
                        detalles = detalles + "Ministerio Público No : &nbsp " + (dato.MovimientoTerceria.DetallesExternos.Numero!=0 ? dato.MovimientoTerceria.DetallesExternos.Numero : '') + '<br>';
                        break;
                    }
                    detalles = detalles  + 'Observaciones: &nbsp' + (dato.MovimientoTerceria.DetallesExternos.Observaciones!=null ? dato.MovimientoTerceriae.DetallesExternos.Observaciones : '') + '<br>';
                    detalles = detalles  + 'Fecha de Envío: &nbsp' + this.obtenFechaConFormato(dato.MovimientoTerceria.FechaMovimiento);
                }
                else
                {
                    let nombreUsuario = '';
                    if(dato.MovimientoTerceria.FechaRecepcion==null)
                    {
                    detalles = detalles +  '<b class="text-primary">' + dato.MovimientoTerceria.AreaQuePresta.Nombre + '</b><br>';
                    }
                    else
                    {
                    detalles = detalles +  '<b class="text-primary">' + dato.Area.Nombre + '</b><br>';
                    }
                    if(dato.MovimientoTerceria.FechaRecepcion==null)
                    {
                        detalles = detalles + '<b class="text-danger">En proceso de Recepción por: ' + dato.MovimientoTerceria.AreaQueRecibe.Nombre + '</b><br>';
                    };
                    if(dato.MovimientoTerceria.UsuarioQuienRecibe!=null)
                    {
                        if(dato.MovimientoTerceria.UsuarioQuienRecibe.IdUsuario==6)
                        {
                            nombreUsuario = "No Asignado"
                        }
                        else
                        {
                            nombreUsuario = dato.MovimientoTerceria.UsuarioQuienRecibe.Nombre + " " + dato.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno + " " + (dato.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno!=null ? dato.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno : "")
                        }
                    }
                    else
                    {
                        nombreUsuario = "No Asignado"
                    }
                    detalles = detalles + "Usuario : &nbsp" + nombreUsuario + '<br>';
                    detalles = detalles + 'Fecha de Envío : '  + this.obtenFechaConFormato(dato.MovimientoTerceria.FechaMovimiento)
                }
            }
            return detalles;
        },
        VerificaConteoSede: function (sede)
        {
            if(sede==1 && this.ConteoSolicitados1==30)
            {
                return true
            };
            if(sede==2 && this.ConteoSolicitados2==30)
            {
                return true
            };
            if(sede==3 && this.ConteoSolicitados3==30)
            {
                return true
            };
            return false;
        },
        VerificaPendientes: function(sede)
        {
            if(sede==1 && this.ConteoPendientes1>0)
            {
                return true
            };
            if(sede==2 && this.ConteoPendientes2==30)
            {
                return true
            };
            if(sede==3 && this.ConteoPendientes3==30)
            {
                return true
            };
            return false;
        },
        AlertaRecepcion: function(datos)
        {
          let arrayTemporal = [];
          if(datos!=null)
          {
            if(datos[0].MovimientoVolumen!=null)
            {
              if(datos[0].MovimientoVolumen.FechaRecepcion==null)
              {
                arrayTemporal.push({
                  Ubicacion: datos[0].MovimientoVolumen.AreaQuePresta!= null ?datos[0].MovimientoVolumen.AreaQuePresta.Nombre : '',
                  Destino: datos[0].MovimientoVolumen.AreaQueRecibe!=null ? datos[0].MovimientoVolumen.AreaQueRecibe.Nombre : '',
                  FechaEnvio : this.obtenFechaConFormato(datos[0].MovimientoVolumen.FechaMovimiento)
                })
              }
            }
          }
          return arrayTemporal;
        }
    },
    
    created(){
        this.ObtenConteo();
        this.Etiqueta = "Datos del Documento"
        this.areaModal = this.$store.state.Login_Usuario;
    }
}
</script>

<style scoped>
input[type="text"]:read-only {
    background: #504f54;
  }

input[type="text"]:read-only:focus {
      color: #fff;
    }
#modalSolicitud{
    overflow-y:auto;
    max-height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Solicitudes/NuevaSolicitudArchivo.vue